import SetUpPassword from './SetUpPassword';

export default SetUpPassword;
